import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { MenuItem } from 'types/global';

type DashboardProps = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
};

export default function Dashboard({ selected, onSelect }: DashboardProps) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/dashboard"
			selected={selected === MenuItem.Dashboard}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.Dashboard)}
		>
			<ListItemIcon>
				<DashboardIcon />
			</ListItemIcon>
			<ListItemText primary={t('general:dashboard')} />
		</ListItem>
	);
}
